import { render } from "./WorkOrderKanbanBoard.vue?vue&type=template&id=7046c6c9"
import script from "./WorkOrderKanbanBoard.vue?vue&type=script&lang=js"
export * from "./WorkOrderKanbanBoard.vue?vue&type=script&lang=js"

import "./WorkOrderKanbanBoard.vue?vue&type=style&index=0&id=7046c6c9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__